export type CloudProjectListItem = {
  projectKey: string
  projectName: string
  updatedAt?: number | string | null
  resolution?: string
}

/** 统一处理接口里可能出现的数字时间戳或文本时间。 */
function normalizeUpdatedAt(value: unknown): number | string | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (typeof value === 'string') {
    const text = value.trim()
    return text || null
  }
  return null
}

/** 从配置的云端列表接口读取工程列表，并归一化字段命名差异。 */
export async function fetchCloudProjectListIfConfigured(): Promise<{
  skipped: boolean
  items: CloudProjectListItem[]
}> {
  const url = (import.meta.env.VITE_CLOUD_PROJECT_LIST_URL as string | undefined)?.trim()
  if (!url) return { skipped: true, items: [] }

  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  })
  if (!res.ok) {
    throw new Error(`云端工程列表获取失败：HTTP ${res.status}`)
  }

  const json = (await res.json()) as { data?: unknown; items?: unknown }
  const raw = Array.isArray(json.items) ? json.items : Array.isArray(json.data) ? json.data : []
  const rawItems: Array<CloudProjectListItem | null> = raw
    .map((item) => {
      const row = item as Record<string, unknown>
      const projectKey = String(
        row.projectKey ?? row.project_key ?? row.guid ?? row.id ?? '',
      ).trim()
      const projectName = String(
        row.projectName ?? row.project_name ?? row.name ?? '未命名工程',
      ).trim()
      const updatedAt = normalizeUpdatedAt(
        row.updatedAt ?? row.updated_at ?? row.update_time ?? row.mtime ?? null,
      )
      if (!projectKey) return null
      return { projectKey, projectName: projectName || '未命名工程', updatedAt }
    })
  const items = rawItems.filter(
    (item: CloudProjectListItem | null): item is CloudProjectListItem => item !== null,
  )

  return { skipped: false, items }
}
